import createNotification from "./notification-props";
import { notificationPropsVar } from "../../app/cache";

export const reactiveMutations = {
  createNotification: createNotification(notificationPropsVar),
}
